import type { FaireProductEntity } from "../../entity_types/product";

export const p_uucanf82hv: FaireProductEntity = {
  token: "p_uucanf82hv",
  type: "product",
  name: "Mini sets of cards with envelopes",
  brandToken: "b_3nkm1llvx0",
  brandName: "Bat Flower Press",
  imageUrl:
    "https://cdn.faire.com/fastly/bedadc00c7043c24fa94cf075d849baca92db94023b0aa08bb74e10b87bd9aa3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/63fb18d941d8941c3b15b669918df42e57462338182cb52d471d0b0796be4769.jpeg",
    "https://cdn.faire.com/fastly/d859ef193d5dc3e56a0bba0b40311c12d05ab7a23172e09d02cb4853f037484d.jpeg",
    "https://cdn.faire.com/fastly/fcf2c15c65fb145f35b201151577c2363fe7f72f91aaf14386cf5a65d2d8780e.jpeg",
    "https://cdn.faire.com/fastly/3b8864e7748c9553891d370cfd98befb8474978bd3b5f75c7c9699a7937179cf.jpeg",
    "https://cdn.faire.com/fastly/0220e7bdcf46894827cc7aa23743f4cc41d9d29095fa685df4eb33565202a0dc.jpeg",
    "https://cdn.faire.com/fastly/c0ed9ce2706e949bf1c284e841141ff3335f944a321fba4b998de2157eff4d96.jpeg",
    "https://cdn.faire.com/fastly/edfc92bfa0fe9d1eb5652a09969cbcb35d3ba30697c989568b844df001777569.jpeg",
    "https://cdn.faire.com/fastly/ff8eb21ee9efd574f9504ae92111da5fd25d32281cf30b5764b1df2d0a7e42ad.jpeg",
    "https://cdn.faire.com/fastly/baca479dd385c85ca84fcedc3dba6e383f4010b43b10b4b48867c8dba8bf4ff8.jpeg",
    "https://cdn.faire.com/fastly/6c9e099eb3d674008e892f376bad2301957eb847f6ccc36f005e967b52151edc.jpeg",
    "https://cdn.faire.com/fastly/9a05605e6c643c476aa27d8a21dbc4523d2c676b7a2c4d88259455ab016bd94a.jpeg",
    "https://cdn.faire.com/fastly/c9bd12fb026fe293be2d390858fbe04636659fef2c5d20484bb74ed751224688.jpeg",
    "https://cdn.faire.com/fastly/419c644b4c974917faa8744955c334232759a3fa7045420ff5fd493302cfb891.jpeg",
    "https://cdn.faire.com/fastly/245a4156ba1587dda8dfe496738c528171354ece0c7324c73103ed15ac059a8d.jpeg",
    "https://cdn.faire.com/fastly/dc9004fa7367c438b447b2ed06b1d122b8de67d1c6cb898350acc6fa09605c8d.jpeg",
    "https://cdn.faire.com/fastly/61250779bb2241b5d47388cbe9ab827287f205c76aedff9b1e6d239228602bc0.jpeg",
    "https://cdn.faire.com/fastly/d91257bffb72213a8379465cc12b5454149ba68fad1b2b4ad13b1e5700f7f2ae.jpeg",
    "https://cdn.faire.com/fastly/77a9c0a142103b203fc0fc92def9448f05182f8178fb181d13f9b7f19ecb37b4.jpeg",
    "https://cdn.faire.com/fastly/a742b3deccb4fb68fb4192623dcac06f60ea0ca84b43ef4a49a9ceb65ee53eb8.jpeg",
  ],
  priceDollars: 12,
  description:
    'NoWaste paper is made in small batches from locally sourced recycled materials and dyed with organic marigold and indigo pigments.\n\n• 100% recycled cotton paper made from mat-board off cuts collected at The Museum of Modern Art.\n\n• Great for letterpress, stationers and an excellent "Thank You" note. Paper accepts ink and paint mediums.\n\n• Paper varies in weight, color and texture.\n\n• Each set contains 10 sheets paper of 3 1/2 x 5" (Approx.) and 10 envelopes.\n\n• Sparkle Moss, Sparkle Ivy & Blush are colors that shine! See video for reference.\n\n• Made in Tarrytown, NY.',
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:08.757Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
